import { APITypesV2 } from "@cur8/api-client";
import { usePatientQuery } from "hooks/queries/usePatientQuery";
import { useSiteQuery } from "hooks/queries/useSiteQuery";
import { useVisitQuery } from "hooks/queries/useVisitQuery";
import { useConfig } from "render/context/ConfigContext";

const ProdTestingPatientGroup = "fcacd5b9-631e-47d4-9aa7-e953fbf9a0ba";
const MoodSiteId = "SE-ARN14";

export function useShowNekoLens({
  patientId,
  visitId,
}: {
  patientId: string;
  visitId: string;
}): boolean {
  const { stageType: environment } = useConfig();
  const { data: patientData } = usePatientQuery({ patientId });
  const { data: visit } = useVisitQuery({ patientId, visitId });
  // TEMPORARY: direct site fetch. Remove (along with useSiteQuery and
  // the getSite method on client.ts) once NekoLens is released to the
  // public and the visibility gate is no longer needed.
  const { data: site } = useSiteQuery({ siteId: visit?.siteId });

  if (environment === "development") {
    return true;
  }

  const groupIds = patientData?.groupIds ?? [];

  if (groupIds.includes(ProdTestingPatientGroup)) {
    return true;
  }

  if (visit?.siteId === MoodSiteId) {
    const isClosedToPublic = site?.isClosedToPublic === true;
    const isNotPublic =
      site?.visibility === APITypesV2.SiteVisibility.Internal ||
      site?.visibility === APITypesV2.SiteVisibility.Restricted;

    return isClosedToPublic && isNotPublic;
  }

  return false;
}
